module.exports = __webpack_public_path__ + "static/media/16.90b20160.gif";